import { useSelector as reduxUseSelector } from 'react-redux';
import { ApplicationSelectors } from './selectors';

export const createApplicationHooks = (useSelector: typeof reduxUseSelector) => ({
  useApplicationLanguage: () => useSelector(ApplicationSelectors.language),
  useApplicationTimer: () => useSelector(ApplicationSelectors.timer),
  useMobileAppConfig: () => useSelector(ApplicationSelectors.mobileAppConfig),
  useEnvironment: () => useSelector(ApplicationSelectors.environment),
});
